var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3143 8.57153H8.68575C7.68003 8.57153 6.86632 9.40725 6.86632 10.4287L6.85718 21.5715C6.85718 22.593 7.68003 23.4287 8.68575 23.4287H23.3143C24.32 23.4287 25.1429 22.593 25.1429 21.5715V10.4287C25.1429 9.40725 24.32 8.57153 23.3143 8.57153ZM23.3143 21.5715H8.68575V12.2858L16 16.9287L23.3143 12.2858V21.5715ZM16 15.0715L8.68575 10.4287H23.3143L16 15.0715Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.eefbef2a.svg";
export { ForwardRef as ReactComponent };